var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { set as _set } from 'lodash';
import { jwtDecode } from "jwt-decode";
import { getSubdomain } from '@/utils';
import { tokenRefreshService } from '@/services/tokenRefresh';
var axiosConfig = axios.create({
    baseURL: "".concat(process.env.REACT_APP_API_URL),
    headers: {
        'Content-Type': 'application/json'
    }
});
axiosConfig.interceptors.request.use(function (axiosConf) { return __awaiter(void 0, void 0, void 0, function () {
    var token, decode, error_1, organization, subdomain;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(typeof window !== 'undefined')) return [3 /*break*/, 8];
                token = localStorage.getItem("token");
                if (!(token && typeof token === 'string')) return [3 /*break*/, 7];
                decode = null;
                try {
                    decode = jwtDecode(token);
                }
                catch (e) {
                    null;
                }
                if (!decode) {
                    localStorage.clear();
                    return [2 /*return*/, Promise.reject(new Error('Invalid Token'))];
                }
                if (!tokenRefreshService.isTokenExpiredOrExpiringSoon(token, 5)) return [3 /*break*/, 6];
                if (!tokenRefreshService.hasValidRefreshToken()) return [3 /*break*/, 5];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                console.log('Token expired/expiring, attempting refresh...');
                return [4 /*yield*/, tokenRefreshService.refreshToken()];
            case 2:
                token = _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.error('Token refresh failed:', error_1);
                localStorage.clear();
                window.location.href = "/login";
                return [2 /*return*/, Promise.reject(new Error('Token refresh failed'))];
            case 4: return [3 /*break*/, 6];
            case 5:
                localStorage.clear();
                window.location.href = "/login";
                return [2 /*return*/, Promise.reject(new Error('Token Expired'))];
            case 6:
                if (token)
                    _set(axiosConf, 'headers.Authorization', "Bearer ".concat(token));
                _a.label = 7;
            case 7:
                organization = localStorage.getItem("organization");
                if (organization) {
                    subdomain = getSubdomain(organization);
                    if (subdomain) {
                        _set(axiosConf, 'headers.x-domain', subdomain);
                    }
                }
                _a.label = 8;
            case 8: return [2 /*return*/, axiosConf];
        }
    });
}); }, function (error) { return Promise.reject(error); });
var interceptor = axiosConfig.interceptors.response.use(function (response) { return response; }, function (error) {
    var _a;
    // TODO:: implement Global error response handler here
    console.log(error);
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
        localStorage.clear();
        window.location.href = "/login";
    }
    return Promise.reject(error);
});
export default axiosConfig;
